import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'
import useCampaignContribution from '@hooks/useCampaignContribution'

import type { CampaignModel } from '@models/types'

import PaymentImage from '../../assets/payment.svg'

const AddPaymentButton = (props: { campaign: CampaignModel }) => {
  const { campaign } = props

  const { callbacks: { createOrEditCampaignContribution } } = useCampaignContribution({ campaign_id: campaign.id })

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        marginTop: 'medium',
        padding: 'large',
      }}
      onClick={() => createOrEditCampaignContribution()}
      forceBottomBorder
      showAngleIcon
    >
      <Image backgroundSize="contain" url={PaymentImage} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Add Payment</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Add a payment or contribution</Text>
      </Box>
    </ListItem>
  )
}
export default AddPaymentButton
